export const red = {
  black: "#000000",
  white: "#ffffff",
  body: "#cc9999",
  header: "#cc3333",
};

export const blue = {
  black: "#000000",
  white: "#ffffff",
  body: "#99ccff",
  header: "#6699ff",
};

export const green = {
  black: "#000000",
  white: "#ffffff",
  body: "#99cc99",
  header: "#66cc66",
};

export const gray = {
  black: "#000000",
  white: "#ffffff",
  body: "#666666",
  header: "#999999",
};
